import React, { Component } from 'react';
import { connect } from 'react-redux';
import { feasibilityState, feasibilityDispatcher, messageDispatcher, configuratorState, siteSettingsState, combineStates, combineDispatchers, popupDispatcher } from '../../../../store';
import { PropTypes } from 'prop-types';
import { UiGroup } from '.';
import { hasAnyAssignableValues } from '../../../../util';
import { AssignmentType, FeasibilityType } from '../../../../model';
import { getLanguages } from '../../../../services';
import { getFeasibleAssignedValue, getITCTPayload, getFeasibleValues, feasiblyEnabled, setBasePageValues, setValues, getAllVariables } from '../../../../util';
import { isEqual } from 'lodash';
import { IconButton } from '../../../../components/actionPanel/IconButton';
import { translate } from '../../../../services/Translator';
import { FeasibilityResultPopup } from '../../../../components/FeasibilityResultPopup';
import { ActionPanel, AddToCartButton } from '../../../../components';
import { calculatorIcon, warningIcon1 } from '../../../../../style/images';
import { SvgImage } from '../../../../components';


export class FeasibilityPopupComponent extends Component {

  apiCalls = FeasibilityType.APICalls;

  payload = {};
  selectedValues = {};
  descriptionString = [];

  state = {
    enabledFields: [],
    itctData: {},
    itctFields: {},
    initialLoad: true,
    coreFields: ["Extension", "Accuracyclass", "Fs", "BurdenVA"],
    basePageValues: [],
    ratioValues: [],
    IthtimeIdynkAValues: []
  }

  componentDidMount() {
    this.props.fetchFeasibilityValues();
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.feasibilityConfiguration,
      nextProps.feasibilityConfiguration) || !this.state.enabledFields?.length) {
      this.setState({
        enabledFields: feasiblyEnabled(this.state.enabledFields, nextProps.feasibilityConfiguration),
        ratioValues: setValues('Selector.varCompleteratioA',this.state.ratioValues, nextProps.materialKey, nextProps.configurations, this.state.initialLoad),
        IthtimeIdynkAValues: setValues('Selector.varIthtimeIdynkA',this.state.IthtimeIdynkAValues, nextProps.materialKey, nextProps.configurations, this.state.initialLoad),
        basePageValues: setBasePageValues(this.state.basePageValues, nextProps.configurations, nextProps.materialKey, this.state.initialLoad),
        itctData: { ...this.state.itctData, ...this.addMoreCores(nextProps.feasibilityConfiguration.data, nextProps.feasibilityConfiguration.fields) },
        itctFields: {
          ...this.state.itctFields, ...nextProps.feasibilityConfiguration.fields?.reduce((obj, item) => {
            if (obj[item.fieldNo] && obj[item.fieldNo]?.coreNo !== item.coreNo) {
              obj[item.fieldNo + "_" + item.coreNo] = { ...item }
              return obj;
            } else {
              obj[item.fieldNo] = { ...item }
              return obj;
            }
          }, {})
        }
      });
    }
  }

//add all core fileds into seperate lists
  addMoreCores(itctData, itctFields){
    const coreFields = itctFields && itctFields.filter(f=> f.coreNo > 0 && (f.fieldNo == 'CorePrecisionClass' || f.fieldNo == 'CoreBurden' || f.fieldNo == 'CoreSecurityFactor' || f.fieldNo == 'CoreExtension'));
    if(coreFields && itctData){
      coreFields.forEach(coreField => {
        let coreFiledName = coreField.fieldNo + '_' + coreField.coreNo;
        if(!itctData?.[coreFiledName] && itctData[coreField.fieldNo]){
          itctData[coreFiledName] =  itctData[coreField.fieldNo];
        }
      })
    }

    return itctData;
  }

  amountFn = (amount) => {
    return amount;
  }

  getFeasibilityConfiguration = () => {
    const { configurations, materialKey } = this.props;
    const configuration = configurations[materialKey] && configurations[materialKey][0];
    const itctSettings = this.props.siteSettings?.properties?.itct;
    const tpuConfiguration = itctSettings.tpuConfiguration[this.props.currentNode?.nodeId]
    if (configuration && configuration.model.children) {
      configuration.model.children = configuration?.model?.children?.map((c) => {
        return this.getFeasibilityChildrens(c, itctSettings.customFields || [], tpuConfiguration)
      })
    }
    return configuration;
  }

  getAssignedValue = (modeValue, itctValue, fullyQualifiedName, author) => {

    if(fullyQualifiedName == 'Selector.varStandard' && !this.selectedValues['Selector.varType']){
      return null;
    }
    if(modeValue && modeValue.userAssigned){
      return modeValue;
    }
    else if(itctValue){
      return itctValue;
    }

    if(fullyQualifiedName.indexOf('Core') > -1 && itctValue){
      return itctValue;
    }
    else if(modeValue){
      return modeValue;
    }

    /* else if(fullyQualifiedName.indexOf('Core') > -1 && modeValue && modeValue.author && (modeValue.author == 3 || modeValue.author == 5) ){
      return modeValue;
    }
    else if(fullyQualifiedName.indexOf('Core') == -1 && modeValue){
      return modeValue;
    } */
    else{
      return null;
    }
  }

  enableCalculateButton = () =>{
    if(this.selectedValues['Selector.varCompleteratioA'])
    {
      const itctSettings = this.props.siteSettings?.properties?.itct;
      const ratioValue = this.selectedValues['Selector.varCompleteratioA'];
      const coreNumber = ratioValue.replace('//','/').split('/').length - 1;
      let enableButton = false;
      let fielCount = 0;
      let valuesRemoved = false;
      let hasCD = this.selectedValues['Selector.varCompleteratioA']?.toLowerCase().indexOf('cd') > -1? true: false;

      Object.keys(this.selectedValues).forEach(s => {
        if(((hasCD)?itctSettings.CDmandatoryFields.includes(s):itctSettings.mandatoryFields.includes(s)) && this.selectedValues[s]){
          fielCount ++;
        }
        if(!this.selectedValues[s]){
          valuesRemoved = true;
        }
      });

      if(fielCount == ((hasCD)?itctSettings.CDmandatoryFields.length: itctSettings.mandatoryFields.length) && this.isAllCoreSelected(coreNumber) && !this.getMandatoryFields(this.getFeasibilityConfiguration())){
        enableButton = true;
      }

       return !valuesRemoved && (!hasCD)?(enableButton || this.state.itctFields["PrimaryTurnsCount"]?.defaultValue) : (enableButton);

    }
  }

  isAllCoreSelected = (coreNumber) => {
    let allCoresSelected = true;
    for (let i = 1; i <= coreNumber; i ++){
      let filedExtension = 'Selector.GrpCore'+i+'.varCore' + i + 'Extension';
      let filedAccuracyclass = 'Selector.GrpCore'+i+'.varCore' + i + 'Accuracyclass';
      let filedSecurityFactor = 'Selector.GrpCore'+i+'.varCore'+i+'Fs';
      let filedCoreBurden = 'Selector.GrpCore'+i+'.varCore'+i+'BurdenVA';

      //if(!this.selectedValues[filedExtension] || !this.selectedValues[filedAccuracyclass] || !this.selectedValues[filedSecurityFactor] || !this.selectedValues[filedCoreBurden]){
      if(!this.selectedValues[filedExtension] || !this.selectedValues[filedAccuracyclass] || !this.selectedValues[filedCoreBurden]){
        allCoresSelected = false;
      }
    }

    return allCoresSelected;
  }

  getCoreNumbers = (configurations, materialKey) => {
    const ratio = configurations[materialKey][0].model.children[0].variables.firstOrDefault(f=>f.fullyQualifiedName == 'Selector.varCompleteratioA').assignedValue?.name;
    if(ratio && ratio!=''){
      return ratio.replace('//','/').split('/').length - 1;
    }
    else{
      return 0;
    }
    
  }

  getFeasibilityChildrens = (children, customFields, tpuConfiguration) => {
    const { itctData, itctFields, enabledFields, basePageValues } = this.state;
    const { configurations, materialKey } = this.props;
    const itctSettings = this.props.siteSettings?.properties?.itct;
    let coreNo = 0;
    let allCoresSelected = true;
    let showChildren = children.fullyQualifiedName.indexOf("Core") > -1 ? Object.keys(itctData)?.find(k => {
      ////let coreNo = Math.max.apply(Math, this.props.feasibilityConfiguration?.fields?.map(f => f.coreNo)) + 1;
      /* if(configurations[materialKey][0].model.children[0].variables.firstOrDefault(f=>f.fullyQualifiedName == 'Selector.varCompleteratioA').assignedValue != null){
        coreNo = configurations[materialKey][0].model.children[0].variables.firstOrDefault(f=>f.fullyQualifiedName == 'Selector.varCompleteratioA').assignedValue.name.replace('//','/').split('/').length - 1;
      } */
      coreNo = this.getCoreNumbers(configurations, materialKey);
      if (k.indexOf("Core") > -1 && children.fullyQualifiedName.substr(children.fullyQualifiedName.indexOf("Core") + 4, 1) <= coreNo) {
        return true;
      }
      return false;
    }) : children.show;
    return {
      ...children,
      variables: children?.variables?.map((v) => {
        let regex = [];
        if (v.fullyQualifiedName === "Selector.varType") {
          regex = tpuConfiguration || [];
        }
        let isCustomField = customFields?.includes(v.fullyQualifiedName);

        //Hiding and showing of core dependent fields
        //Show core dependent fields only if value provided to add core fields
        const coreNumber = this.getCoreNumbers(configurations, materialKey);
        /* if(configurations[materialKey][0].model.children[0].variables.firstOrDefault(f=>f.fullyQualifiedName == 'Selector.varCompleteratioA').assignedValue != null){
          coreNumber = configurations[materialKey][0].model.children[0].variables.firstOrDefault(f=>f.fullyQualifiedName == 'Selector.varCompleteratioA').assignedValue.name.replace('//','/').split('/').length - 1;
        } */
        if(v.name == 'varIthtimeIdynkA' || v.name == 'varIcthA' || v.name == 'varFrequencyHz' || v.name == 'varCapacitivedDivider' || v.name == 'varPolarity'){
          if(enabledFields.length == 0){
            v.show =false;
          }
        
        else if (coreNumber > 0){
          //let canShow = true;
          /* for (let i = 1; i <= coreNumber; i ++){
            let filedExtension = 'Selector.GrpCore'+i+'.varCore' + i + 'Extension';
            let filedAccuracyclass = 'Selector.GrpCore'+i+'.varCore' + i + 'Accuracyclass';
            //let filedSecurityFactor = 'Selector.GrpCore'+i+'.varCore'+i+'Fs';
            let filedCoreBurden = 'Selector.GrpCore'+i+'.varCore'+i+'BurdenVA';

            if(!this.selectedValues[filedExtension] || !this.selectedValues[filedAccuracyclass] || !this.selectedValues[filedCoreBurden]){
              allCoresSelected = false;
            }
          }
          v.show = allCoresSelected; */
          v.show = this.allCoresSelected(coreNumber);
        }
          else
          v.show = false;
        }
        

        //calculate possible assigned value
        let itctAssignedValue = getFeasibleAssignedValue(v.fullyQualifiedName, itctFields);
        let newAssignedValue = v.assignedValue?.name || itctAssignedValue?.name;
        //Condition to set newAssignedValue null for standard in the initial load if itct suggesting default value
        //This is to make user force to select standard and get correct values for Insulation Voltage
        if(this.state.initialLoad && v.fullyQualifiedName == 'Selector.varStandard' && !v.assignedValue){
          newAssignedValue = null;
        }
        const fromITCT = v.values.firstOrDefault(vl => vl.name == newAssignedValue) && v.values.firstOrDefault(vl => vl.name == newAssignedValue).fromITCT;
        const userInputValue = v.values.firstOrDefault(value => value.name == newAssignedValue ) ? false : true;
        //const assignvarIthtimeIdynkA = coreNumber > 0 && v.fullyQualifiedName == 'Selector.varIthtimeIdynkA' && this.selectedValues[v.fullyQualifiedName] ? true: false;
        // if (itctAssignedValue?.name && this.selectedValues[v.fullyQualifiedName] != itctAssignedValue?.name) {
        //   if (!v.assignedValue?.name) {
        //     this.props.assignValue(v.fullyQualifiedName, itctAssignedValue?.name);
        //   }
        // }
        if(v.fullyQualifiedName == 'Selector.varAmbienttemperature' && newAssignedValue && newAssignedValue != '40'){
          v.assignedValue.name = '40';
          v.assignedValue.title = '40';
      }
        //   this.props.addMessage({timeout: 15000, messageText: 'Only 40C as a standard value to be considered.', messageType: 'warning'});
        // }
        
        //No Capacitive divider (CD) -> No values selected
        //Contais 'Type' -> Value from the base page. Base page value (Model value) in not in sync with ITCT value. So clearing the value binded from base page
        if(v.fullyQualifiedName == 'Selector.varCapacitivedDivider' && (this.selectedValues['Selector.varCompleteratioA'] && this.selectedValues['Selector.varCompleteratioA']?.toLowerCase().indexOf('cd') ==-1 || (v.assignedValue && v.assignedValue.name?.indexOf('type') > -1))){
          if(this.selectedValues['Selector.varPolarity']){
            (this.selectedValues['Selector.varPolarity'] == "P1-P2")? v.assignedValue = {name: 'NONONO NORMAL ACCESSORIES', title: 'NONONO NORMAL ACCESSORIES'} : v.assignedValue = {name: 'RONONO NORMAL ACCESSORIES', title: 'RONONO NORMAL ACCESSORIES'};
          }
          else if(!this.selectedValues['Selector.varPolarity'])
          v.assignedValue = {name: 'No Capacitive divider (CD)', title: 'No Capacitive divider (CD)'};
        }
        //From base page with CD
        if(v.fullyQualifiedName == 'Selector.varCapacitivedDivider' && (this.selectedValues['Selector.varCompleteratioA'] && this.selectedValues['Selector.varCompleteratioA']?.toLowerCase().indexOf('cd') > -1 || (v.assignedValue && v.assignedValue.name?.indexOf('type') > -1))){
          if(!this.selectedValues['Selector.varPolarity']){
            v.assignedValue = null;
            
          }
        }

        if (this.selectedValues[v.fullyQualifiedName] != newAssignedValue && newAssignedValue != 'Not applicable' && enabledFields.includes(v.fullyQualifiedName)) {
          if (v.fullyQualifiedName?.indexOf('Core') === -1 && newAssignedValue && !fromITCT && !userInputValue && v.fullyQualifiedName == 'Selector.varType') {
            //this.props.assignValue(v.fullyQualifiedName, newAssignedValue);
          }
          this.selectedValues[v.fullyQualifiedName] = newAssignedValue;
          this.payload[v.fullyQualifiedName] = getITCTPayload(v.fullyQualifiedName, this.selectedValues[v.fullyQualifiedName], itctFields, this.props.siteSettings?.properties?.itct, this.selectedValues);
          //if (this.state.initialLoad && v.fullyQualifiedName === "Selector.varType" && this.selectedValues[v.fullyQualifiedName]) {
          if (this.state.initialLoad && this.selectedValues[v.fullyQualifiedName]) {
            this.assignValue(v.fullyQualifiedName, this.selectedValues[v.fullyQualifiedName]);
          } else if (!this.state.initialLoad) {
            this.assignValue(v.fullyQualifiedName, this.selectedValues[v.fullyQualifiedName]);
          }
        }
        return {
          ...v,
          show: v.fullyQualifiedName?.indexOf("Core") > -1 && this.state.coreFields?.find(c => v.fullyQualifiedName?.indexOf(c) > -1) ? showChildren : v.show,
          assignedValue: this.getAssignedValue(v.assignedValue, itctAssignedValue, v.fullyQualifiedName, v.author, this.state.initialLoad),//v.assignedValue || (itctAssignedValue?.name ? itctAssignedValue : null),
          //assignedValue: itctAssignedValue || this.getAssignedValue(v.assignedValue, itctAssignedValue, v.fullyQualifiedName, v.author, this.state.initialLoad),//v.assignedValue || (itctAssignedValue?.name ? itctAssignedValue : null),
          //assignedValue: v.assignedValue || (itctAssignedValue?.name ? itctAssignedValue : null),
          notEnabled: !enabledFields?.includes(v.fullyQualifiedName),
          custom: isCustomField,
          values: getFeasibleValues(v.fullyQualifiedName, regex, isCustomField, v.values?.map(val => ({ ...val, fromConfiguration: true })), itctData, itctFields, this.selectedValues, this.state.ratioValues, this.state.IthtimeIdynkAValues, itctSettings, materialKey),
        }
      }),
      show: showChildren,
      children: children?.children?.map((ch) => this.getFeasibilityChildrens(ch, customFields, tpuConfiguration))
    }
  }

  sortPayload = (payload) =>{
    let payloadSorted = [];
    const itctSettings = this.props.siteSettings?.properties?.itct;
    const {itctFieldOrder} = itctSettings;

    itctFieldOrder.forEach( item => {
        if(payload.firstOrDefault(p => p.fieldNo == item)){
            payloadSorted = [...payloadSorted, payload.firstOrDefault(p => p.fieldNo == item)];
        }
        else if(item.indexOf('Core') > -1 && item.indexOf('_') > -1 ){
          const coreNumber = item.split('_')[1];
          const terminalNo = item.split('_')[2];
          if(payload.firstOrDefault(p => p.fieldNo + '_' + p.coreNo + '_' + p.terminalNo == item)){
            payloadSorted = [...payloadSorted, payload.firstOrDefault(p => p.fieldNo + '_' + p.coreNo + '_' + p.terminalNo == item)];
          }
        }
    });

    return payloadSorted;
}

  assignValue = (variable, value) => {
    let selectedVariable = this.findVariableValues(variable);
    if (variable?.indexOf('Core') === -1 && value && selectedVariable?.values?.find(v => v.name === value)) {
      //this.props.assignValue(variable, value);
    }

    /* if(variable == 'Selector.varAmbienttemperature' && value != '40'){
      this.props.addMessage({timeout: 15000, messageText: 'Only 40C as a standard value to be considered.', messageType: 'warning'});
    } */

    this.payload[variable] = getITCTPayload(variable, value, this.state.itctFields, this.props.siteSettings?.properties?.itct, this.selectedValues);
    let itctPayload = [];
    let itctPayloadSorted = [];
    Object.keys(this.payload)?.forEach(k => {
      itctPayload = [...itctPayload, ...this.payload[k]];
    });

    itctPayloadSorted = this.sortPayload(itctPayload);

    if (this.apiCalls[variable]?.length) {
      this.apiCalls[variable]?.map(call => this.props.assignITCTValue(itctPayloadSorted, call));
    } else {
      this.props.assignITCTValue(itctPayloadSorted, null);
    }
    if (this.state.initialLoad) {
      Object.keys(this.payload)?.forEach(k => {
        if (this.apiCalls[k] && k !== variable) {
          this.apiCalls[k]?.map(call => this.props.assignITCTValue(itctPayloadSorted, call));
        }
      });
      this.setState({ initialLoad: false });
    }
  }

  getAssignedValueString(configuration) {
    let stringArray = "";
    let coreStringArray = "";
    if (configuration) {
      this.findInPropertyPath(configuration.model.children, 'children', child => {
        child?.variables?.map(v => {
          let currentField = "";
          if (v.show && v.assignedValue?.name && v.assignedValue?.name != 'Not applicable') {
            let unit = "";
            //For fields with unit
              if(v.title.includes("[")){
                let squareIndex = v.title.indexOf("[");
                let squareIndexEnd = v.title.indexOf("]");
                unit = unit = v.title.substring(squareIndex+1, squareIndexEnd);


                //Removing "var" and unit values from name and appending with value and unit
                currentField = v.title.substring(0,squareIndex) + " : " + v.assignedValue?.title + " "+ unit +"; ";
                
                
              }
              else
              //For fields without unit
              currentField =  v.title.charAt(0).toUpperCase() + v.title.substr(1).toLowerCase() + " : " + v.assignedValue?.title +"; ";

          }
          //Core field values array
          if(v.name.indexOf("Core") > -1){
            coreStringArray += currentField;
          }
          //Non-core field values array
          else{
            stringArray += currentField;
          }
        })
      })
    }
    let primaryIndex = -1;
    if(stringArray.indexOf("Complete ratio") > -1){
      primaryIndex = stringArray.substring(stringArray.indexOf("Complete ratio")).indexOf(";") + stringArray.indexOf("Complete ratio");
      coreStringArray = coreStringArray?.length > 0? coreStringArray + "<br/> " : coreStringArray;
    }
    else if(stringArray.indexOf("Type") > -1){
      primaryIndex = stringArray.substring(stringArray.indexOf("Type")).indexOf(";");
    }
    
    if(primaryIndex> -1){
      stringArray =  stringArray.substring(0,primaryIndex+1) + " " + coreStringArray +stringArray.substring(primaryIndex+1);
    }
    else{
    stringArray =  coreStringArray + stringArray;
    }
    if(document.getElementById("description"))
    document.getElementById("description").innerHTML = stringArray;
    return stringArray;
  }

  calculate = () => {
    const { itctFields } = this.state;
    let itctPayloadSorted = [];
    let itctPayload = [];
    const feasibilityConfiguration1 = this.getFeasibilityConfiguration();
    const { model } = feasibilityConfiguration1;
    //const descriptionString = this.getAssignedValueString(feasibilityConfiguration1);
    const descriptionString = this.getProductDescription(true);
    Object.keys(this.payload)?.forEach(k => {
      itctPayload = [...itctPayload, ...this.payload[k]];
    });
    //Add Polarity value to Accessory when Polarity is seleced and Ration is without CD
    if(this.selectedValues['Selector.varPolarity'] && !itctPayload.firstOrDefault(p => p.fieldNo == 'Accessories')){
      const val = this.selectedValues['Selector.varPolarity'] == 'P1-P2' ? 'N0N0N0' : 'R0N0N0';
      itctPayload = [...itctPayload, {asyncData: false, coreNo: 0, defaultValue: null, editable: true, fieldNo: "Accessories", optional: true, terminalNo: 0, value: val}];
    }
    //Correct terminal values of Cores
    const coreNumber = itctPayload.firstOrDefault(p => p.fieldNo == 'Ratio').value.split('/').length - 1;
    for(let i = 0; i < coreNumber; i ++){
      itctPayload.firstOrDefault(p => p.fieldNo == 'CoreExtension' && p.coreNo == i) ? itctPayload.firstOrDefault(p => p.fieldNo == 'CoreExtension' && p.coreNo == i).terminalNo = 0 : null;
      itctPayload.firstOrDefault(p => p.fieldNo == 'CorePrecisionClass' && p.coreNo == i) ? itctPayload.firstOrDefault(p => p.fieldNo == 'CorePrecisionClass' && p.coreNo == i).terminalNo = 0 : null;
      itctPayload.firstOrDefault(p => p.fieldNo == 'CoreBurden' && p.coreNo == i) ? itctPayload.firstOrDefault(p => p.fieldNo == 'CoreBurden' && p.coreNo == i).terminalNo = 0 : null;
      itctPayload.firstOrDefault(p => p.fieldNo == 'CoreSecurityFactor' && p.coreNo == i) ? itctPayload.firstOrDefault(p => p.fieldNo == 'CoreSecurityFactor' && p.coreNo == i).terminalNo = 0 : null;
      itctPayload.firstOrDefault(p => p.fieldNo == 'CorePowerFactor' && p.coreNo == i) ? itctPayload.firstOrDefault(p => p.fieldNo == 'CorePowerFactor' && p.coreNo == i).terminalNo = 0 : null;

      //Push the core values for multiple terminals based on Ratio
      if(itctPayload.firstOrDefault(p => p.fieldNo == 'Ratio').value.split('-').length - 1 > 0){
        const terminalNumber = itctPayload.firstOrDefault(p => p.fieldNo == 'Ratio').value.split('-').length - 1;
        //push 
        for(let t = 1; t <= terminalNumber; t++){
          itctPayload.push({...itctPayload.firstOrDefault(p => p.fieldNo == 'CoreExtension' && p.coreNo == i), terminalNo: t});
          itctPayload.push({...itctPayload.firstOrDefault(p => p.fieldNo == 'CorePrecisionClass' && p.coreNo == i), terminalNo: t});
          itctPayload.push({...itctPayload.firstOrDefault(p => p.fieldNo == 'CoreBurden' && p.coreNo == i), terminalNo: t});
          itctPayload.push({...itctPayload.firstOrDefault(p => p.fieldNo == 'CoreSecurityFactor' && p.coreNo == i), terminalNo: t});
          itctPayload.push({...itctPayload.firstOrDefault(p => p.fieldNo == 'CorePowerFactor' && p.coreNo == i), terminalNo: t});
        }
      }

    }
    
    itctPayload.push({ ...itctFields["PrimaryTurnsCount"], value: itctFields["PrimaryTurnsCount"]?.defaultValue });
    itctPayloadSorted = this.sortPayload(itctPayload);
    this.props.calculatePhysibility(itctPayloadSorted, 'Structure').then(resonse => {
      if(resonse?.data?.data){
        const feasibilityResult = JSON.parse(resonse.data.data)
        const logData = feasibilityResult?.log;
        const status = feasibilityResult?.status;
        this.props.setPopup(
          {
            title: translate('Feasibility Status'),
            component: <FeasibilityResultPopup
            text = {logData}
            showPopup = 'true'
            status= {status}
            description={descriptionString}
            />,
            showHeader: true,
            keepOpen: true,
          }
        );

      }
    });
  }

  findInPropertyPath = (source, property, predicate) => {
    return source?.map(c => {
      predicate(c);
      this.findInPropertyPath(c[property], property, predicate).firstOrDefault();
    });
  }

  findVariableValues = (variable) => {
    return this.props.configuration?.model?.children?.map(c => c.variables.find(v => v.fullyQualifiedName === variable) || c.children.map(ci => ci.variables.find(vi => vi.fullyQualifiedName === variable))?.find(ci => ci))?.find(ci => ci);
  }

  getMandatoryFields = (configuration) => {
    const { deflateModelVariables } = this.props;
    const itctSettings = this.props.siteSettings?.properties?.itct;
    let coresEnabled = false;
    let coreNumber = 0;
    let allCoreSelected = false;
    let warningText = "";
    let hasCD = this.selectedValues['Selector.varCompleteratioA']?.toLowerCase().indexOf('cd') > -1? true: false;

    //check cores are enabled
    if(this.selectedValues['Selector.varCompleteratioA']){
      coresEnabled = true;
      coreNumber = this.selectedValues['Selector.varCompleteratioA'].replace('//','/').split('/').length - 1;
    }
    if(coreNumber > 0){
      allCoreSelected = this.allCoresSelected(coreNumber);
    }
    const b = this.selectedValues;
    let filedsTobeSelected = [];
    (!hasCD)?itctSettings.mandatoryFields.forEach(m => {
      if(!this.selectedValues[m]){
        if(m == 'Selector.varIthtimeIdynkA' || m == 'Selector.varIcthA' || m == 'Selector.varFrequencyHz' || m == 'Selector.varCapacitivedDivider' || m == 'Selector.varPolarity'){
          if(allCoreSelected){
            filedsTobeSelected.push(m);
          }
        }
        else{
          filedsTobeSelected.push(m);
        }
      }
    }):
    // Check for all cores enabled in the case of ratio with +CD
    itctSettings.CDmandatoryFields.forEach(m => {
      if(!this.selectedValues[m]){
        if(m == 'Selector.varIthtimeIdynkA' || m == 'Selector.varIcthA' || m == 'Selector.varFrequencyHz'  || m == 'Selector.varPolarity' || m == 'Selector.varCapacitivedDivider'){
          if(allCoreSelected){
            filedsTobeSelected.push(m);
          }
        }
        else{
          filedsTobeSelected.push(m);
        }
      }
    })


    //Check for core fields
    if(coreNumber > 0){
      for (let i = 1; i <= coreNumber; i ++){
        if(!this.selectedValues['Selector.GrpCore'+i+'.varCore' + i + 'Extension']){
          filedsTobeSelected.push('Selector.GrpCore'+i+'.varCore' + i + 'Extension');
        }
        if(!this.selectedValues['Selector.GrpCore'+i+'.varCore' + i + 'Accuracyclass']){
          filedsTobeSelected.push('Selector.GrpCore'+i+'.varCore' + i + 'Accuracyclass');
        }
        if(!this.selectedValues['Selector.GrpCore'+i+'.varCore'+i+'BurdenVA']){
          filedsTobeSelected.push('Selector.GrpCore'+i+'.varCore'+i+'BurdenVA');
        }
      }
    }

    if(filedsTobeSelected.length > 0){
      const {model} = configuration;
      const variables = getAllVariables(model);

      filedsTobeSelected.forEach( f => {
        warningText = warningText + variables.firstOrDefault(v => v.fullyQualifiedName == f)?.title + ';';
      })
      
    }

    return warningText;
  }
    
  allCoresSelected = (coreNumber) => {
    let allCoresSelected = true;
    for (let i = 1; i <= coreNumber; i ++){
      let filedExtension = 'Selector.GrpCore'+i+'.varCore' + i + 'Extension';
      let filedAccuracyclass = 'Selector.GrpCore'+i+'.varCore' + i + 'Accuracyclass';
      //let filedSecurityFactor = 'Selector.GrpCore'+i+'.varCore'+i+'Fs';
      let filedCoreBurden = 'Selector.GrpCore'+i+'.varCore'+i+'BurdenVA';

      if(!this.selectedValues[filedExtension] || !this.selectedValues[filedAccuracyclass] || !this.selectedValues[filedCoreBurden]){
        allCoresSelected = false;
      }
    }

    return allCoresSelected;
  }

  getProductDescription = () => {
    const itctSettings = this.props.siteSettings?.properties?.itct;
    //line 1 - Type Ratio A; core1 acc.cl Fs(if present)/core2 acc.cl Fs(if present)/core3… 
    //(depending on qty of cores); Core1 Burden/Core2 Burden/ Core3… VA ; Ext. core1/core2/core3… % 
    let line1 = this.getLineDescription(itctSettings.line1Description);
    //Standard; Insul.voltage kV; Ith(time)/Idyn kA; Frequency Hz; Amb.temp. °C; Altitude m; Icth A; Polarity, E
    let line2 = this.getLineDescription(itctSettings.line2Description);
    let line3 = this.getLineDescription(itctSettings.line3Description);

    //const productDescription = line1 + "<br/> " + (line2.length > 0? line2 +'; E' :' E') + "<br/> " + line3;
    const productDescription = (line1.includes("Ext")? line1 + '%' : line1) + "<br/> " + (line2.length > 0? line2 +'; E' :' E') + "<br/> " + line3;

    if(document.getElementById("description")){
      document.getElementById("description").innerHTML = productDescription;
    }

    return productDescription;
  }

  getLineDescription = (lineFormat) => {
    let description = '';
    const itctSettings = this.props.siteSettings?.properties?.itct;
    let unitArray = []
    let unit = '';
    let unitType = '';
    if(lineFormat){
      lineFormat.forEach(element => {
        //Line 1 Type and Ratio description 
        if(element.indexOf('#') > -1){
          const number = element.split('#').length;
          for(let j=0; j<number; j++){
            if(this.selectedValues[element.split('#')[j]]){
              if(element.split('#')[j] == "Selector.varCompleteratioA"){
                description =  description + this.selectedValueWithUnit(element.split('#')[j], this.selectedValues[element.split('#')[j]]).replace("cd","CD") + ';';
              } 
              else
                description = description + this.selectedValues[element.split('#')[j]].replace("cd","CD") + ' ';
          }
        }
      }

        if(element.indexOf('/') > -1){
          const number = element.split('/').length;
          for(let i=0; i<number; i++){
            if(element.split('/')[i].indexOf(';') > -1){
              const subNumber = element.split('/')[i].split(';').length;
              for(let n = 0; n < subNumber; n++){
                if(this.selectedValues[element.split('/')[i].split(';')[n]]){
                  if(n == 0 && i > 0){
                    description = description + '/';
                  }
                //Checking for unit
                if(itctSettings.units[element.split('/')[i].split(';')[n]]){
                  unitArray = itctSettings.units[element.split('/')[i].split(';')[n]];
                  unit = unitArray[0];
                  unitType = unitArray[1];
                }
                //description = n == 0 ? description + this.selectedValues[element.split('/')[i].split(';')[n]] : description + ' ' +this.selectedValues[element.split('/')[i].split(';')[n]];
                description = n == 0 ? description + this.selectedValueWithUnit(element.split('/')[i].split(';')[n], this.selectedValues[element.split('/')[i].split(';')[n]]) : description + ' ' + this.selectedValueWithUnit(element.split('/')[i].split(';')[n], this.selectedValues[element.split('/')[i].split(';')[n]]);
                }
              }
            }
            else{
            if(this.selectedValues[element.split('/')[i]]){
              if(description.slice(-1) != ';' &&  description.slice(-1) != '/'){
                description = description+'/';
              }
              description = description + this.selectedValueWithUnit(element.split('/')[i], this.selectedValues[element.split('/')[i]]);
            }
          }
          }

          description = description.slice(-1) != ';' ? description + ';': description;
        }
        else if(this.selectedValues[element]){
          description = description + this.selectedValueWithUnit(element, this.selectedValues[element]) + ';';
        }
      });
    }
    return description.slice(-1) == ';' ? description.slice(0,-1).replaceAll(";","; ") : description.replaceAll(";","; ");
  }

  selectedValueWithUnit = (fieldName, value) => {
    const itctSettings = this.props.siteSettings?.properties?.itct;
    let unitArray = []
    let unit = '';
    let unitType = '';
    let coreNumber = '';
    let valueWithUnit = value;
    const isCoreField = fieldName.indexOf('Core' > -1)
    const numberOfCores = this.selectedValues['Selector.varCompleteratioA'] ? this.selectedValues['Selector.varCompleteratioA'].replace('//','/').split('/').length - 1 : 0;
    if(itctSettings.units[fieldName]){
      unitArray = itctSettings.units[fieldName];
      unit = unitArray[0];
      unitType = unitArray[1];
      //unitType = 0 - Unit should add at the beginning of value
      //unitType = 1 - Unit should add at the end of value
      //unitType = 2 - Unit should be added at the end of last core value
      //unitType = 3 - Unit should be added at the beginning of first core value
      //unitType = 4 - Unit should add at the end of value preceeded by Icth=
      if(unitType == '0'){
        valueWithUnit = unit + valueWithUnit;
      }
      else if(unitType == '1'){
        valueWithUnit = valueWithUnit + " " + unit;
      }
      else if (unitType == '2'){
        if(numberOfCores > 0 && isCoreField){
          coreNumber = unitArray[2];
          if(numberOfCores == coreNumber){
            valueWithUnit = valueWithUnit + " " + unit;
          }
        }
      }
      else if(unitType == '3'){
        if(numberOfCores > 0 && isCoreField){
          coreNumber = unitArray[2];
          if(coreNumber == 1){
            valueWithUnit = unit + " " + valueWithUnit;
          }
        }
      }
      else if(unitType == '4'){
        valueWithUnit = "Icth=" + valueWithUnit + " " + unit;
      }
    }

    return valueWithUnit;
  }

  render() {
    const { deflateModelVariables, removeValue } = this.props;
    const addToCart = this.props.feasibilityConfiguration && this.props.feasibilityConfiguration.result && this.props.feasibilityConfiguration.result.status && this.props.feasibilityConfiguration.result.status == 'Ok' && this.enableCalculateButton() ? true: false;
    const guid = addToCart ? this.props.feasibilityConfiguration.resultId : '';
    const feasibilityConfiguration = this.getFeasibilityConfiguration();
    const { model } = feasibilityConfiguration;
    //const valueString = this.getAssignedValueString(feasibilityConfiguration);
    const valueString = this.getProductDescription();
    //const testString = this.getProductDescription();
    const message = this.getMandatoryFields(feasibilityConfiguration);
    if (!model) {
      return null;
    }
    let product = [];
    if(addToCart){
      product = [...product, 
        {
          name: '123', 
          code:'123',
          description: valueString.replaceAll("<br/>",";"), 
          amount: 1,
          properties: [{name: 'Description', value: valueString.replaceAll("<br/>","")}]
        }];
      /* const product = {
        code: "123",
        description: valueString
      } */
    }

    const uiGroups = model.children?.filter(group => hasAnyAssignableValues(group) && group.fullyQualifiedName != 'Availability').map(
      (child, key) => child.show &&
        <UiGroup key={child.title + key + AssignmentType.createHashKey(child.variables) + "popup"}
          group={child}
          hasChildren={child.hasChildren}
          children={child.children}
          configuration={feasibilityConfiguration}
          assignValue={this.assignValue}
          removeValue={removeValue}
          lang={getLanguages().first()}
          fromFeasibility={true}
          deflateModelVariables={deflateModelVariables}
        />
    );
    return <>
    <div>
      <div style={{padding: "16px 14px", flexDirection: "column",minWidth: "100%"}} className="popup-message">
        <small  id = "description" ></small>
      {message != '' && 
          <small style={{ color: "orange"}} className="warning-message">
          <SvgImage source={ warningIcon1 }/>
           {translate(
            'Please select mandatory values: ')}
            {message}
          </small>
        }
        </div>
      <div>
        <div style={{float: "right", paddingRight:"5px"}}>
      {<IconButton  className="blue-button" icon={ calculatorIcon } style = {{height: "23px"}}
        text={ translate( 'Calculate' ) } disabled={!this.enableCalculateButton()} onClick={ this.calculate } />}
        </div>
        <div style={{float: "right", paddingRight:"2px"}}>
      {addToCart && <AddToCartButton 
        className="add-to-shopping-cart" 
        product = {product[0]} 
        fixAmountFunc={ this.amountFn }
        fromITCT = {true}
        guid = {guid}
        />}
      </div>
      {uiGroups}
      </div></div>
    </>
  }

}

FeasibilityPopupComponent.propTypes = {
  assignValue: PropTypes.func.isRequired,
  className: PropTypes.string,
  configuration: PropTypes.shape({}),
  removeValue: PropTypes.func.isRequired,
  fetchFeasibilityValues: PropTypes.func.isRequired,
  feasibilityConfiguration: PropTypes.shape({}),
};

export const FeasibilityPopup = connect(combineStates(feasibilityState, configuratorState, siteSettingsState), combineDispatchers(messageDispatcher, feasibilityDispatcher, popupDispatcher))(FeasibilityPopupComponent);